export default "__VITE_ASSET__3814c71d__"